import React from "react";
import './paycancel.css';

export class PaymentCancel extends React.Component {
    render() {
        return (
        <div className="pay-cancel-container">
            <div className="content">
            <h2>Payment Cancelled</h2>
            <p>Your payment was not completed.</p>
            <p>You can try again anytime.</p>
            <a href="/pay" className="link">Try again</a>
            </div>
        </div>
        );
    }
}